import { Injectable } from '@angular/core';
import { VesselService } from './vessel.service';
import { HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { ShipyardService } from './shipyard.service';
import { Shipyard } from 'icreate/common/models/shipyard';
import { ProjectStatus, Vessel } from 'icreate/common/models/vessel';
import { AccessRequestStatus } from 'icreate/common/models/access-request';
import { PopUpNotificationComponent } from '@components/pop-up-notification/pop-up-notification.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class PermissionGuardService {
    constructor(
        private vesselService: VesselService,
        private shipyardService: ShipyardService,
        private authService: AuthService,
        private dialog: MatDialog
    ) {}

    readonly permissionError = new Error('No permission');

    dialogRef;

    showPermissionDeniedDialog() {
        if (this.dialogRef) return;
        this.dialogRef = this.dialog.open(PopUpNotificationComponent, {
            width: '474px',
            data: {
                title: 'general.api.permission-denied.title',
                message: 'general.api.permission-denied.message',
                message2: 'general.api.permission-denied.message-2',
            },
        });

        this.dialogRef.afterClosed().subscribe(() => {
            this.dialogRef = null;
        });
    }

    checkPermission(req: HttpRequest<any>): boolean {
        if (req.method === 'GET') {
            return true;
        }

        if (req.body?.skipGuard) return true;

        const vesselId = this.vesselService.getActiveVesselId();
        if (!vesselId) return true;

        const shipyardList = this.shipyardService.getUpdatedList();
        if (shipyardList.length === 0) return true;

        const vessels: any[] = shipyardList.flatMap((shipyard: Shipyard) =>
            shipyard.vessels.map(vessel => ({
                ...vessel,
                shipyardName: shipyard.name,
            }))
        );
        const currentUser = this.authService.getCurrentUser();
        return vessels.some((vessel: Vessel) => {
            if (vessel.id !== vesselId) return false;

            if (!vessel.ownerOid && vessel.projectStatus == ProjectStatus.undefined) return true;

            if (vessel.ownerOid === currentUser.oid) {
                return true;
            }

            return vessel.VesselAccessRequests?.some(
                request => request.userOid === currentUser.oid && request.requestStatus === AccessRequestStatus.Editing
            );
        });
    }
}
